module.exports = __webpack_public_path__ + "219c39c51b.png";